import React from 'react';
import { Col, Row, Card, Placeholder } from 'react-bootstrap';
//import PaySettings from './PaySettings';
//import Account from './Account';

import Banner from './Banner';
import Documents from './Documents';
import Styles from './Styles';
import CompanyForm from './CompanyForm';
import useCompany from './useCompany';

const Company = () => {
 const { data, isLoading, onError, onSubmitData } = useCompany();

 return (
  <>
   <Banner />
   <Row className="g-3 mt-1">
    <Col lg={8}>
     {!data ? (
      <Card className="overflow-hidden mb-3">
       <Card.Header variant="top" style={{ height: 120 }} className="p-0">
        <span className="placeholder w-100 h-100" />
       </Card.Header>
       <Card.Body>
        <Placeholder as={Card.Title} animation="glow" className="mb-2">
         <Placeholder xs={4} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow">
         <Placeholder xs={7} className="me-3" />
         <Placeholder xs={4} />
         <Placeholder xs={4} className="me-3" />
         <Placeholder xs={6} />
         <Placeholder xs={8} />
        </Placeholder>
        <Placeholder.Button variant="primary" xs={3} className="float-end" />
       </Card.Body>
      </Card>
     ) : (
      <CompanyForm className="mb-3" data={data} isLoading={isLoading} onSubmitData={onSubmitData} onError={onError} />
     )}

     {!data ? (
      <Card className="overflow-hidden">
       <Card.Body>
        <Placeholder as={Card.Title} animation="glow" className="mb-2">
         <Placeholder xs={4} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow">
         <Placeholder xs={10} />
         <Placeholder xs={7} />
         <Placeholder xs={4} />
         <Placeholder xs={3} />
         <Placeholder xs={4} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow">
         <Placeholder xs={12} style={{ height: '50px' }} />
         <Placeholder xs={12} className="my-2" style={{ height: '50px' }} />
         <Placeholder xs={12} style={{ height: '50px' }} />
        </Placeholder>
        <Placeholder.Button variant="primary" xs={3} className="float-end" />
       </Card.Body>
      </Card>
     ) : (
      <Documents data={data} isLoading={isLoading} onSubmitData={onSubmitData} onError={onError} />
     )}

     {/* <CalcularFechaPago /> */}
    </Col>
    <Col lg={4}>
     <div className="sticky-sidebar">
      {/* <Card className="mb-3">
       <Card.Body as={Flex} wrap="wrap" justifyContent="center" alignItems="center">
        <div className="flex-grow-1">
         <Link className="btn btn-sm btn-link ps-0" to="#!">
          Chatea con nosotros!
         </Link>
        </div>

        <div>
         <AvatarGroup dense>
          {[
           {
            id: 1,
            img: user1,
            size: 'xl'
           },
           {
            id: 2,
            img: user2,
            size: 'xl'
           },
           {
            id: 3,
            img: user3,
            size: 'xl'
           },
           {
            id: 4,
            name: '+50',
            size: 'xl'
           }
          ].map(({ img, name, size, id }) => {
           return (
            <Avatar
             src={img && img}
             key={id}
             size={size}
             name={name && name}
             isExact
             className="border border-3 rounded-circle border-light"
            />
           );
          })}
         </AvatarGroup>
        </div>
       </Card.Body>
      </Card> */}
      {/* sticky-sidebar */}
      {/* <Account /> */}
      {/*  <BillingSettings /> */}
      <Styles onSubmitData={onSubmitData} />
      {/* <PaySettings /> */}
      {/*  <ChangePassword /> */}
     </div>
    </Col>
   </Row>
  </>
 );
};

export default Company;
